import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for AuthStore, for use in the registry */ export const AuthStoreActionTypes = [
    ActionType.ClearAccessToken,
    ActionType.FetchAccessToken,
    ActionType.FetchAccessTokenSucceeded,
    ActionType.FetchAccessTokenFailed
];
